<script>
import BaseInput from '@/components/BaseInput.vue';
import SupplierManualDirForm from '@/components/dir/supplierManual/SupplierManualDirForm.vue';
import SupplierManualDirList from '@/components/dir/supplierManual/SupplierManualDirList.vue';
import api from '@/api/supplierManual';

export default {
  name: 'SupplierManualDir',
  model: { prop: 'value', event: 'change' },
  components: { SupplierManualDirList, SupplierManualDirForm, BaseInput },
  props: {
    value: String,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    selectedItem() {
      return this.items.find(item => item['@id'] === this.value);
    },
    displayValue() {
      return this.selectedItem?.name ?? '';
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      api.fetchList({}, true).then(r => { this.items = r.items; });
    },
    async add(select) {
      const data = await this.$refs.form.open();
      if (!data) return;

      const res = await api.create(data, true);
      this.items.push(res);

      if (select) {
        this.$emit('change', res['@id']);
      }
    },
    async select() {
      const data = await this.$refs.list.open(this.items);
      if (!data) return;

      this.$emit('change', data);
    },
    async edit(id) {
      const data = await api.fetchItem(id, {}, true);
      const res = await this.$refs.form.open(data);

      if (!res) return;
      await api.update(id, res, true);
      this.fetchList();
    },
    async remove(id) {
      await api.delete(id, true);
      this.fetchList();
    },
  },
};
</script>

<template lang="pug">
.supplier-manual-dir
  BaseInput(:value="displayValue" disabled)
  template(v-if="value")
    button.lbtn.edit(@click="edit(selectedItem.id)")
      Icon(name="edit" colored pointer)
    button.lbtn.delete(@click="$emit('change', null);")
      Icon(name="cross" colored pointer)
  template(v-else)
    button.lbtn.add(@click="add(true)")
      Icon(name="plus" colored pointer)
    button.lbtn.select(@click="select")
      Icon(name="more" colored pointer)
  SupplierManualDirList(ref="list" :items="items" @add="add(false)" @edit="edit" @delete="remove")
  SupplierManualDirForm(ref="form")
</template>

<style scoped lang="scss">
.supplier-manual-dir {
  display: grid;
  grid-template-columns: 1fr 40px 40px;
  gap: 10px;
}

.lbtn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.add, .edit {
  background: #D3EAFF;

  svg {
    color: #33A1FB;
  }
}

.select {
  background: #33A1FB;

  svg {
    color: #fff;
  }
}

.delete {
  background: #F4DDEA;

  svg {
    color: #D063AC;
  }
}
</style>
